import type { ComponentProps } from 'react';

const AvatarFemale = (props: ComponentProps<'svg'>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
      fill="#FFF2E8"
    />
    <mask
      id="mask0_208_43423"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="60"
      height="60"
    >
      <path
        d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
        fill="#FFF2E8"
      />
    </mask>
    <g mask="url(#mask0_208_43423)">
      <path
        d="M32.3979 15.2923C34.662 15.2923 36.4974 13.4569 36.4974 11.1928C36.4974 8.92869 34.662 7.09326 32.3979 7.09326C30.1338 7.09326 28.2983 8.92869 28.2983 11.1928C28.2983 13.4569 30.1338 15.2923 32.3979 15.2923Z"
        fill="#5B1D1E"
      />
      <path
        d="M33.9317 44.8279H30.5581C25.3697 44.8279 21.1631 40.6213 21.1631 35.4329V24.6992C21.1631 19.5108 25.3697 15.3042 30.5581 15.3042H33.9317C39.1201 15.3042 43.3267 19.5108 43.3267 24.6992V35.4329C43.3327 40.6213 39.126 44.8279 33.9317 44.8279Z"
        fill="#FFBF9F"
      />
      <path
        d="M21.1577 29.7925V24.6933C21.1577 19.505 25.3643 15.2983 30.5527 15.2983H33.9263C39.1147 15.2983 43.3213 19.505 43.3213 24.6933V29.7925L31.9926 19.0587L21.1577 29.7925Z"
        fill="#5B1D1E"
      />
      <path
        d="M19.3579 36.2123C21.2506 36.2123 22.785 34.6779 22.785 32.7851C22.785 30.8923 21.2506 29.3579 19.3579 29.3579C17.4651 29.3579 15.9307 30.8923 15.9307 32.7851C15.9307 34.6779 17.4651 36.2123 19.3579 36.2123Z"
        fill="#FFBF9F"
      />
      <path
        d="M44.9619 36.2123C46.8546 36.2123 48.389 34.6779 48.389 32.7851C48.389 30.8923 46.8546 29.3579 44.9619 29.3579C43.0691 29.3579 41.5347 30.8923 41.5347 32.7851C41.5347 34.6779 43.0691 36.2123 44.9619 36.2123Z"
        fill="#FFBF9F"
      />
      <path
        d="M27.175 33.1183C27.8027 33.1183 28.3115 32.3192 28.3115 31.3333C28.3115 30.3475 27.8027 29.5483 27.175 29.5483C26.5474 29.5483 26.0386 30.3475 26.0386 31.3333C26.0386 32.3192 26.5474 33.1183 27.175 33.1183Z"
        fill="#5B1D1E"
      />
      <path
        d="M38.3694 32.7672C38.997 32.7672 39.5058 31.9681 39.5058 30.9823C39.5058 29.9964 38.997 29.1973 38.3694 29.1973C37.7417 29.1973 37.2329 29.9964 37.2329 30.9823C37.2329 31.9681 37.7417 32.7672 38.3694 32.7672Z"
        fill="#5B1D1E"
      />
      <path
        d="M28.2912 35.6172L32.9917 38.7588C32.9917 38.7588 31.1055 41.4005 28.7493 39.7881C26.4943 38.2411 28.2912 35.6172 28.2912 35.6172Z"
        fill="white"
      />
      <path
        d="M32.6436 29.3101V34.1236C32.6436 34.1236 34.8986 33.838 34.7379 35.1589C34.6368 36.0276 33.2981 36.926 33.2981 36.926"
        stroke="#5B1D1E"
        strokeWidth="0.892495"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M66.5957 94.0403H-1.81104L-1.81104 63.4694C-1.81104 54.4135 5.53122 47.0713 14.5871 47.0713H50.1976C59.2535 47.0713 66.5957 54.4135 66.5957 63.4694V94.0403Z"
        fill="#FFBF9F"
      />
      <mask
        id="mask1_208_43423"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-2"
        y="47"
        width="69"
        height="48"
      >
        <path
          d="M66.5957 94.0403H-1.81104L-1.81104 63.4694C-1.81104 54.4135 5.53122 47.0713 14.5871 47.0713H50.1976C59.2535 47.0713 66.5957 54.4135 66.5957 63.4694V94.0403Z"
          fill="#FFBF9F"
        />
      </mask>
      <g mask="url(#mask1_208_43423)">
        <path
          d="M34.3171 71.853L-27.4614 87.6026L9.20226 34.1719L34.3171 71.853Z"
          fill="#F58D7A"
        />
        <path
          d="M-9.60547 77.9457L52.53 38.789L71.2664 37.3193L75.8479 107.618L-9.60547 77.9457Z"
          fill="#E06257"
        />
      </g>
    </g>
  </svg>
);

export default AvatarFemale;
